<template>
  <div>
    <Input
      label="global.name"
      v-model="form.name"
      :defaultValue="selectedItem.name"
      :state="validateState('name')"
    />

    <Input
      label="global.description"
      v-model="form.description"
      :defaultValue="selectedItem.description"
    />

    <Input
      label="global.username"
      v-model="form.username"
      :defaultValue="selectedItem.username"
      :state="validateState('username')"
    />

    <Input
      label="global.password"
      v-model="form.password"
      :defaultValue="selectedItem.password"
      :type="`password`"
      :state="validateState('password')"
    />

    <Input
      label="global.ipV4"
      v-model="form.ipv4"
      :defaultValue="selectedItem.ip_v4"
      :state="validateState('ipv4')"
    />

    <Input
      label="global.ipV6"
      v-model="form.ipv6"
      :defaultValue="selectedItem.ip_v6"
    />

    <Input
      label="global.imagesPath"
      v-model="form.image_path"
      :defaultValue="selectedItem.image_path"
    />

    <Input
      label="global.isoPath"
      v-model="form.iso_path"
      :defaultValue="selectedItem.iso_path"
    />

    <b-form-group :label="$t('global.isActive')">
      <multiselect
        v-model="form.is_active"
        :options="booleanList"
        track-by="id"
        label="name"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="false"
        :placeholder="$t('global.isActive')"
        :show-no-results="false"
      />
    </b-form-group>

    <b-form-group :label="$t('global.isPublic')">
      <multiselect
        v-model="form.is_public"
        :options="booleanList"
        track-by="id"
        label="name"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="false"
        :placeholder="$t('global.isPublic')"
        :show-no-results="false"
      />
    </b-form-group>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import {
  required,
  requiredIf,
  minLength,
  maxLength,
} from 'vuelidate/lib/validators'

export default {
  name: 'RegistryForm',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
    selectedItem: String | Object,
  },
  data() {
    return {
      form: {
        name: '',
        description: '',
        username: '',
        password: '',
        ipv4: '',
        ipv6: '',
        image_path: '',
        iso_path: '',
        is_active: '',
        is_public: '',
      },
      booleanList: [
        { id: 'true', name: this.$t('global.true') },
        { id: 'false', name: this.$t('global.false') },
      ],
    }
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(100),
      },
      username: {
        required: requiredIf(function () {
          return this.selectedItem == ''
        }),
      },
      password: {
        required: requiredIf(function () {
          return this.selectedItem == ''
        }),
      },
      ipv4: {
        required,
      },
    },
  },
  created() {},
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        name: this.form.name,
      }
      if (this.form.username || this.form.password) {
        params.credentials = {}
        if (this.form.username) params.credentials.username = this.form.username
        if (this.form.password) params.credentials.password = this.form.password
      }

      if (this.form.description) params.description = this.form.description

      if (this.form.ipv4) params.ip_v4 = this.form.ipv4

      if (this.form.ipv6) params.ip_v6 = this.form.ipv6

      if (this.form.image_path) params.image_path = this.form.image_path

      if (this.form.iso_path) params.iso_path = this.form.iso_path

      if (this.form.is_active && this.form.is_active.id)
        params.is_active = this.form.is_active.id.toString() == 'true'

      if (this.form.is_public && this.form.is_public.id)
        params.is_public = this.form.is_public.id.toString() == 'true'

      if (this.selectedItem == '') this.insertOperation(params)
      else this.updateOperation(params)
    },
    insertOperation(params) {
      ApiService.post(`repo/servers`, params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
          this.$v.$reset()
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
    updateOperation(params) {
      ApiService.put(`repo/servers/${this.selectedItem.id}`, params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
          this.$v.$reset()
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
    selectedItem(newVal) {
      this.$v.$reset()
      if (newVal) {
        if (newVal.is_active == true || newVal.is_active == false)
          this.form.is_active = {
            id: newVal.is_active,
            name: this.$t(`global.${newVal.is_active}`),
          }
        if (newVal.is_public == true || newVal.is_public == false)
          this.form.is_public = {
            id: newVal.is_public,
            name: this.$t(`global.${newVal.is_public}`),
          }
      }
    },
  },
}
</script>
